/* HOLY SPIRIT - Header scroll state (IntersectionObserver + backstop).
   Home: el header transparente permanece transparente mientras el Hero siga
   visible bajo la banda del header, y pasa a negro EXACTO cuando el Hero
   termina (su borde inferior sube por encima de la banda del header). El
   navegador calcula el final real del Hero; no se usan valores fijos.
   En internas el header es negro via CSS (:not([transparent])); esta clase no
   les afecta.

   FIX de reversibilidad (desktop + iOS): en este tema el scroll ocurre dentro
   de un contenedor overflow (.page-wrapper), NO en el documento. En iOS Safari
   un IntersectionObserver con root:null no se recalcula al hacer scroll dentro
   de un contenedor overflow, por lo que al volver al Hero el estado transparente
   no se restauraba (quedaba una franja del negro). Se corrige apuntando el IO
   al contenedor real de scroll y anadiendo un backstop de scroll sobre ese mismo
   contenedor que deriva el estado de la posicion real del Hero. */
(function () {
  var h = document.querySelector('header-component');
  if (!h) return;

  function heroEl() {
    var m = document.getElementById('MainContent');
    if (!m) return null;
    return m.querySelector(':scope > .shopify-section') || m.firstElementChild || null;
  }
  function headerH() {
    return Math.round(h.getBoundingClientRect().height) || 72;
  }
  function setState(on) {
    if (on) h.classList.add('hs-scrolled');
    else h.classList.remove('hs-scrolled');
  }
  /* Contenedor real de scroll: primer ancestro con overflow-y desplazable. Si no
     hay ninguno, el documento/viewport hace scroll (return null). */
  function scrollRoot(el) {
    var n = el && el.parentElement;
    while (n && n !== document.body && n !== document.documentElement) {
      var s = getComputedStyle(n);
      if (/(auto|scroll|overlay)/.test(s.overflowY) && n.scrollHeight > n.clientHeight + 1) return n;
      n = n.parentElement;
    }
    return null;
  }

  var io = null;
  var scrollTarget = null;
  var onScroll = null;

  /* Fuente de verdad: el estado se deriva SIEMPRE de la posicion actual del Hero.
     El navegador calcula el borde inferior real; sin valores fijos. */
  function computeFromPosition(hero) {
    var b = hero.getBoundingClientRect().bottom;
    setState(b <= headerH());
  }

  function build() {
    var hero = heroEl();
    if (!hero) { setState(true); return; } /* sin Hero (internas) -> negro */

    if (io) { io.disconnect(); io = null; }
    var root = scrollRoot(hero);

    /* Backstop fiable sobre el contenedor real de scroll (o window). Garantiza
       que el estado se restaure al volver al tope tambien en iOS. */
    var newTarget = root || window;
    if (onScroll && scrollTarget) scrollTarget.removeEventListener('scroll', onScroll);
    onScroll = function () { computeFromPosition(hero); };
    scrollTarget = newTarget;
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });

    /* IntersectionObserver eficiente, con la RAIZ = contenedor real de scroll.
       La raiz se reduce por la altura del header en el borde superior. */
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (!e) return;
        setState(!e.isIntersecting);
      }, { root: root, rootMargin: '-' + headerH() + 'px 0px 0px 0px', threshold: 0 });
      io.observe(hero);
    }

    /* Estado inicial coherente con la posicion actual (dentro del Hero -> transparente). */
    computeFromPosition(hero);
  }

  build();

  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(build, 150); /* recalcula con la nueva altura de header */
  }, { passive: true });
  window.addEventListener('load', build);
})();
